export default function LeadershipProfile({ name, title, description, image }) {
	return (
	  <div className="flex flex-col items-center group">
		<img src={image} alt={name} className="mb-20" width={241} height={241} />
		<div className="text-center text-white text-[3.1rem] font-medium leading-relaxed tracking-wider [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)] mb-[1.3rem]">
		  {name}
		</div>
		<div className="text-center justify-start text-[#e0ffff] text-[1.9rem] font-medium leading-[2.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)] mb-10">
		  {title}
		</div>
		<div className="text-[2.1rem] md:text-[2rem] leading-[3.1rem] tracking-[.04rem] md:tracking-[.06rem] [text-shadow:_0px_4px_8px_rgb(0_0_0_/_1.00)]">
		{/* <div className="text-[2.1rem] md:text-[2rem] leading-[3.1rem] tracking-[.04rem] md:tracking-[.06rem] [text-shadow:_0px_4px_8px_rgb(0_0_0_/_1.00)] "> */}
		  {description}
		</div>
	  </div>
	);
  }